export const adminPathsRootWithoutFirstSlash = 'AdministratorCompany';

export const adminPaths = {
  root: '/AdministratorCompany',
  withCompany: (companyId) => {
    return adminPaths.root.concat('/', companyId);
  },
  companyInfo: (companyId) => {
    return adminPaths.withCompany(companyId).concat('/info');
  },
  workSchedule: (companyId) => {
    return adminPaths.withCompany(companyId).concat('/work-schedule');
  },
  /*
  пример расширения пути
  companyInfoEdit: (companyId) => {
    return adminPaths.companyInfo(companyId).concat('/edit');
  },
  */
  /*
  // пример вкладки
  companyTest: (companyId) => {
    return adminPaths.withCompany(companyId).concat('/test');
  },
  */
};
